module.exports = __webpack_public_path__ + "static/media/readmore.35660fe2.png";